import './card.scss';

import React from 'react';

export default (props) => {
  // let className = 'c-card';
  let className = 'c-card';
  if (props.arrow) {
    className = 'c-card c-card--arrow c-card--arrow-' + props.arrow;
  }
  if (props.className) {
    className += ' ' + props.className;
  }
  return (
    <div {...props} className={className.trim()}>{props.children}</div>
  );
};



/** WEBPACK FOOTER **
 ** ./components/card/index.js
 **/